export enum WonLostAbbrevation {
    WON = 'W',
    LOST = 'L',
}
